<ui-modal
  [isOpened]="showCreditLines"
  modalTitle="Credit Lines"
  size="xl"
  (isOpenedChange)="modalChanged($event)"
>
  <div class="body">
    <ag-grid-angular
      class="ag-theme-balham-dark credit-lines__ag-grid"
      [columnDefs]="columnDefs"
      [rowData]="rowData"
      [defaultColDef]="defaultColDef"
      [sideBar]="sideBarDef"
      (gridReady)="onGridReady($event)"
      (cellValueChanged)="onCellValueChanged($event)"
      (firstDataRendered)="firstDataRendered()"
    >
    </ag-grid-angular>
  </div>
  <div class="hr"></div>
  <div class="modal-footer">
    <div class="saving">
      <loading-spinner *ngIf="processingInfo === 'Processing'">
      </loading-spinner>
      <div
        *ngIf="processingInfo === 'Saved' || processingInfo === 'Failed'"
        [ngClass]="processingInfo === 'Saved' ? 'success' : 'failed'"
      >
        {{ processingInfo }}
      </div>
    </div>

    <button type="button" (click)="modalChanged(false)" class="ui-button">
      Cancel
    </button>

    <button
      type="button"
      (click)="saveCreditLinesChanges()"
      class="ui-button primary"
      [disabled]="!changes.length"
    >
      Save
    </button>
  </div>
</ui-modal>
